/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./Program.Performance.DomainIndicator.vue?vue&type=template&id=d8dcbfee"
import script from "./Program.Performance.DomainIndicator.vue?vue&type=script&lang=js"
export * from "./Program.Performance.DomainIndicator.vue?vue&type=script&lang=js"
import style0 from "./Program.Performance.DomainIndicator.vue?vue&type=style&index=0&id=d8dcbfee&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports